import { DataBean } from "../DataBean";

export class OrderCatalogForExternal extends DataBean {



    public async getProductionOrderCatalogForExternalFactory(idExternalFactory: any, idAccount: any, idProduct: any, code: any, year: any, month: any, idManufacturingStardard: any, idAttentionOffice: any, state: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getProductionOrderCatalogForExternalFactory_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number", [idExternalFactory, idAccount, idProduct, code, year, month, idManufacturingStardard, idAttentionOffice, state, page, recordsPerPage]);
    }

}